<template lang="pug">
  section.colorbar-careers-videos
    .color-dark-grey.xs-f-small.xs-pb-125m.sm-pb-100m.text-center(v-if="subTitle")
      | {{subTitle}}

    .f-secondary.brand-color-1.text-center.xs-f-grande.sm-f-xgrande.xs-pb-75m
      | {{mainTitle.firstLine}}

    .subtitle-second-line.f-script.text-center.xs-f-xsmall.xs-f-large.sm-f-xlarge
      | {{mainTitle.secondLine}}

    .videos-container
      .video-item(v-for="video in computedVideos" :key="video.options.url")
        .video.xs-pb-15
          VideoPlayer(:options="video.options")

        .video-title.xs-pb-10m.xs-font-xxlarge.brand-color-1.text-center
          | {{video.title}}

        .video-description.xs-f-small.text-center
          | {{video.description}}
          a.description-cta.underline.bold.cta-color-1.f-primary(
            v-if="video.cta && video.cta.href && video.cta.text"
            :href="video.cta.href"
            ) {{ video.cta.text}}

</template>

<script>

import VideoPlayer from '@components/VideoGallery/VideoPlayer';

export default {
  name: "HCBCareersVideos",

  components: {
    VideoPlayer
  },

  props: {
    subTitle: {
      type: String,
      required: true
    },

    mainTitle: {
      type: Object,
      required: true
    },

    videos: {
      type: Array,
      required: true
    }
  },

  computed: {
    computedVideos() {
      return this.videos.map(video => {
        return {
          title: video.title,
          description: video.description,
          cta: video.cta,
          options: {
            image: {
              url: video.thumbnail.url
            },
            url: video.video.url
          }
        };
      });
    },
  }
};

</script>

<style lang="stylus">
.colorbar-careers-videos
  background-color #efeded
  padding 6.5em 4%

  .color-dark-grey
    color color-mister-darker-gray

  .subtitle-second-line
    position relative
    bottom 1.5em

  @media mq-mobile
    padding 1em 0

  @media only screen and (min-width: 1440px)
    padding 6.5em 3%

  .videos-container
    display grid;
    grid-template-columns repeat(3, 1fr)
    row-gap 4.5em
    column-gap 2.4em

  .video-item
    max-width 440px

  .video
    max-width 440px

  .video-title
    font-family font-family-kapra-neue-medium

  .description-cta
    padding-left 0.175em

  @media mq-mobile
    .videos-container
      grid-template-columns 1fr
      row-gap 0

    .video-item
      padding 1em 0

    .video-description
      padding 0 0.7em

</style>